import type { HighlightConfig, HighlightTarget } from './types';

import { add } from './add';
import { remove } from './remove';
import { start } from './start';

// ----------------------------------------------------------------------------

class HighlightManager {
    private readonly config: HighlightConfig;

    constructor(config: HighlightConfig = {}) {
        this.config = config;
    }

    start(element: HTMLElement, find: string, config?: HighlightConfig): void {
        const highlightConfig = { ...this.config, ...config };

        start(element, find, highlightConfig);
    }

    add(element: HighlightTarget, find: string, config?: HighlightConfig): number {
        const highlightConfig = { ...this.config, ...config };

        return add(element, find, highlightConfig);
    }

    remove(element: HTMLElement, config?: HighlightConfig): void {
        const highlightConfig = { ...this.config, ...config };

        remove(element, highlightConfig);
    }

    find(element: HighlightTarget, find: string, config?: HighlightConfig): number {
        const highlightConfig = { ...this.config, ...config };

        return add(element, find, highlightConfig);
    }
}

// ----------------------------------------------------------------------------

export default HighlightManager;
